import {t} from "i18next";
import React from "react";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import useEditDataGroup from "./edit-data-group.hooks";
import TabDetailUser from "./tab-detail-user";
import TabSetDataScope from "./tab-set-data-group";
import SuccessModal from "../../../../component/modal/SuccessModal";
import style from '../DataGroup.module.css'
import {ROUTES} from "../../../../constant/routeConstant";
import ManagementHistory from "../../../../component/management-history/management-history";
import {BackIcon} from "../../../../asset";
import NotifFailedSaved from "../../../../component/modal/NotifFailedSaved";
import ModalSuccessUpdated from "../../../../component/modal/ModalSuccessUpdated";

function EditDataGroup() {
    const {
        handleBack,
        data,
        tab1,
        tab2,
        loading,
        onChangeTab,
        setDepotList,
        setFlag,
        id,
        name,
        desc,
        depotList,
        flag,
        successModalOpen,
        navigate,
        handleUpdate,
        depotListCount,
        depotIdList,
        onSelected,
        setUserManagementOpen,
        userManagementOpen,
        convertTimestamp,
        _onOk,
        failedMessages,
        failedModalOpen,
        setFailedModalOpen
    } =
        useEditDataGroup();
    return (
        <>
            <div className="p-5 h-fit">

                <SuccessModal
                    isOpen={successModalOpen}
                    onOk={() => navigate(ROUTES.DATA_GROUP.LIST)}
                    closable={false}
                    width={280}
                    className={style.successModal}
                    okText="Ok"
                    title="Success"
                    description={`Your data has been edited`}
                />

                <Breadcumbs
                    jmlLevel={4}
                    menuLevel1={`Admin`}
                    menuLevel2={`User Management`}
                    menuLevel3={`Data Group`}
                    menuLevel4={`Edit Data Group`}
                />

                <div className='flex items-center justify-between my-[31px]'>
                    <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => handleBack()}>
                        <img src={BackIcon} alt=""/>
                        <h1 className='font-sans-bold text-2xl'
                            id='title'>{`Detail ${data?.id} - ${data?.data_group_id}`}</h1>
                    </div>

                    <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer'
                         onClick={() => setUserManagementOpen(true)}>
                        <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}
                            <strong>{data?.created_by}</strong> {t("USER_DETAIL:ON")}
                            <strong>{convertTimestamp(data?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")}
                            <strong>{data?.updated_by}</strong> {t("USER_DETAIL:ON")}
                            <strong>{convertTimestamp(data?.updated_at, true)}</strong></p>
                    </div>
                </div>

                <ManagementHistory
                    id={data?.id}
                    detail={data}
                    tableName={'data_group'}
                    userManagementOpen={userManagementOpen}
                    setUserManagementOpen={() => setUserManagementOpen(false)}
                />

                <div className=" bg-white-100 p-5 rounded-[10px] min-h-[500px]">
                    <div className=" flex h-[52px] flex-row">
                        <p
                            className={
                                tab1
                                    ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer`
                                    : `text-gray-100 font-roboto text-2xl font-medium cursor-pointer`
                            }
                            onClick={() => onChangeTab(1)}
                        >
                            Detail User
                        </p>
                        <p
                            className={
                                tab2
                                    ? `text-red-100 font-roboto text-2xl font-medium border-b-2 border-red-100 cursor-pointer ml-2`
                                    : `text-gray-100 font-roboto text-2xl font-medium ml-2 cursor-pointer`
                            }
                            onClick={() => onChangeTab(2)}
                        >
                            Set Data Scope
                        </p>
                    </div>
                    {tab1 ? <TabDetailUser/> :
                        <TabSetDataScope setFlag={setFlag} loading={loading} depotListCount={depotListCount}
                                         depotIdList={depotIdList} onSelected={onSelected} setDepotList={setDepotList}
                                         depotList={depotList}/>}
                </div>
            </div>
            <div className="flex flex-row-reverse gap-[16px] px-5 m-5">
                <PrimaryButton action={handleUpdate} text={t("USER_DETAIL:SAVE")}/>
                <SecondaryButton action={handleBack} text={t("USER_DETAIL:BACK")}/>
            </div>

            <ModalSuccessUpdated
                isVisible={successModalOpen}
                onOk={_onOk}
            />

            <NotifFailedSaved
                visible={failedModalOpen}
                message={failedMessages}
                action={() => {
                    setFailedModalOpen(false)
                }}
            />
        </>
    );
}

export default EditDataGroup;
